module.exports = __webpack_public_path__ + "img/avatar7.069cb5ce.png";